// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"474ad289","376":"4c88be3a","702":"a23f7f09"}[chunkId] + ".chunk.css";
};